import { AiOutlineInfoCircle } from "react-icons/ai";
import classes from "./PayoutPool.module.css";
import Card from "../Card/Card";
import axios from "axios";
import { env } from "../../constants/env";
import { useEffect, useRef, useState } from "react";
import useWindowDimensions from "../../hooks/getWindowDimensions";

const transactions = [
  {
    date: "2024-11-24",
    type: "Challenge Fee",
    amount: "$500",
    accountId: "TRD123456",
    status: "Received",
  },
  {
    date: "2024-11-24",
    type: "Withdrawals",
    amount: "$800",
    accountId: "TRD123456",
    status: "Pending",
  },
  {
    date: "2024-11-24",
    type: "Challenge Fee",
    amount: "$500",
    accountId: "TRD123456",
    status: "Received",
  },
  {
    date: "2024-11-24",
    type: "Withdrawals",
    amount: "$500",
    accountId: "TRD123456",
    status: "Received",
  },
  {
    date: "2024-11-24",
    type: "Challenge Fee",
    amount: "$600",
    accountId: "TRD123456",
    status: "Received",
  },
  {
    date: "2024-11-24",
    type: "Challenge Fee",
    amount: "$600",
    accountId: "TRD123456",
    status: "Failed",
  },
];

const getStatusIcon = (status) => {
  if (status === "Credited")
    return (
      <span style={{ color: "green" }} className={classes.emojiIcon}>
        💰
      </span>
    );
  if (status === "Debited")
    return (
      <span style={{ color: "green" }} className={classes.emojiIcon}>
        💸
      </span>
    );
  if (status === "Pending")
    return (
      <span style={{ color: "orange" }} className={classes.emojiIcon}>
        ⏳
      </span>
    );
  if (status === "Failed")
    return (
      <span style={{ color: "red" }}>
        <img src="/icons/cross-mark.png" />
      </span>
    );
  return null;
};

const PayoutPool = () => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [showPopCard, setShowPopCard] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const scrollRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);

  const limit = 6;
  const { width } = useWindowDimensions();

  const [isMobile, setIsMobile] = useState(false);

  const tooltipTop = (index) => {
    const rowHeight = 48; // or dynamically calculate if responsive
    const offsetTop = 140; // distance from top of page/Card
    return `${offsetTop + index * rowHeight}px`;
  };

  const handleScroll = () => {
    const scroller = scrollRef.current;
    if (!scroller) return;

    const scrollLeft = scroller.scrollLeft;
    const totalScrollWidth = scroller.scrollWidth - scroller.clientWidth;
    const scrollRatio = scrollLeft / totalScrollWidth;

    const index = Math.round(scrollRatio * 1); // 2 items => index 0 or 1
    setActiveIndex(index);
  };

  useEffect(() => {
    const scroller = scrollRef.current;
    if (scroller) {
      scroller.addEventListener("scroll", handleScroll);
      return () => scroller.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const metrics = [
    {
      metric: "Total Funded Traders (Live)",
      tip: "Number of traders currently live and actively funded. These accounts count toward the pool’s drawdown exposure limit.",
      value: data?.totalFundedTraders ? data?.totalFundedTraders : 0,
    },
    {
      metric: "Total Drawdown Exposure Used",
      tip: "The combined static max drawdown from all live funded accounts.",
      value: data?.totalDrawdownExposureUsed
        ? data?.totalDrawdownExposureUsed
        : 0,
    },
    {
      metric: "Remaining Drawdown Capacity",
      tip: "How much drawdown space is still available before the funding limit is reached. Once this hits zero, new passes are queued or refunded.",
      value: data?.remainingDrawdownCapacity
        ? data?.remainingDrawdownCapacity
        : 0,
    },
  ];

  useEffect(() => {
    setIsMobile(width <= 768);
  }, [width]);

  console.log("FINANCE ADATA ", data);

  useEffect(() => {
    fetchFinanceData(page);
  }, [page]);

  const fetchFinanceData = async (page) => {
    try {
      const response = await axios.get(
        `${env.apiUrl}/api/finance?page=${page}&limit=${limit}`
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching finance data:", error);
    }
  };

  const stats = [
    {
      color: "#AC3C3C",
      name: "Initial funding",
      percentage: data?.initialFundingPercentage
        ? data?.initialFundingPercentage
        : 0,
      amount: `${data?.initialFunding ? data?.initialFunding : 0}`,
    },
    {
      color: "#59AC3C",
      name: "Challenge Fees Added",
      percentage: data?.challengeFeesPercentage
        ? data?.challengeFeesPercentage
        : 0,
      amount: `${data?.totalContribution ? data?.totalContribution : 0}`,
    },
  ];

  return (
    <div className={`${classes.wrapper}`}>
      <div
        className={`${classes.titleText} d-flex align-items-center gap-2 position-relative`}
      >
        <h3>Community PAYOUT Pool</h3>
        <div
          onMouseEnter={() => setShowPopCard(true)}
          onMouseLeave={() => setShowPopCard(false)}
          className="position-relative"
        >
          <AiOutlineInfoCircle color="#CECECE" size={20} role="button" />
          {showPopCard && (
            <div className={classes.popCardStyle}>
              The Community Payout Pool is a transparent trackable fund powered
              by 50% of challenge fees and initially seeded with company
              reserves, ensuring fair and sustainable payouts for all traders.
            </div>
          )}
        </div>
      </div>
      {isMobile ? (
        <div className="row mt-3">
          <div className="col-6 pe-2">
            <div
              className={`${classes.mobileStaticsCard} d-flex flex-column justify-content-between`}
            >
              <h6>Balance</h6>
              <h2>{data?.balance ? data?.balance : 0}</h2>
            </div>
          </div>
          <div className="col-6 ps-2">
            <div
              className={`${classes.mobileStaticsCard} d-flex flex-column justify-content-between`}
            >
              <h6>Withdrawals</h6>
              <h2 className={classes.withdrawText}>
                {data?.withdrawnThisMonth ? data?.withdrawnThisMonth : 0}
              </h2>
            </div>
          </div>
          {/* <div className="col-6 pe-2 mt-3">
            <div
              className={`${classes.mobileStaticsCard} d-flex flex-column justify-content-between`}
            >
              <h6>Total contributions</h6>
              <h2>{data?.totalContribution ? data?.totalContribution : 0}</h2>
            </div>
          </div>
          <div className="col-6 ps-2 mt-3">
            <div
              className={`${classes.mobileStaticsCard} d-flex flex-column justify-content-between`}
            >
              <h6>Target pass rate</h6>
              <h2>
                <span>{data?.targetPassRate ? data?.targetPassRate : 0}</span>
              </h2>
            </div>
          </div> */}
        </div>
      ) : (
        <div
          className={`${classes.subText} d-flex align-items-center justify-content-between gap-3 flex-wrap`}
        >
          <div className="d-flex align-items-center gap-3">
            <div>
              Balance: <span>{data?.balance ? data?.balance : 0}</span>
            </div>
            <div>
              Withdrawals:{" "}
              <span>
                {data?.withdrawnThisMonth ? data?.withdrawnThisMonth : 0}
              </span>
            </div>
            <div>
              Contributions:{" "}
              <span>
                {data?.totalContribution ? data?.totalContribution : 0}
              </span>
            </div>
          </div>
          {/* <div className="d-flex align-items-center gap-3">
            <div>
              Target pass rate:{" "}
              <span>{data?.targetPassRate ? data?.targetPassRate : 0}</span>
            </div>
            <div>
              Current pass rate:{" "}
              <span>
                {data?.withdrawnThisMonth ? data?.withdrawnThisMonth : 0}
              </span>
            </div>
          </div> */}
        </div>
      )}
      <>
        {/* DESKTOP VIEW */}
        <div className="row mt-4 d-none d-md-flex">
          {/* Pool Overview */}
          <div className="col-md-4">
            <Card className={classes.poolCard}>
              <h4>Pool OVERVIEW</h4>
              <div className={classes.shareContainer}>
                <div
                  className={`${classes.shareWrapper} d-flex align-items-center gap-1`}
                >
                  <div
                    className={classes.redShare}
                    style={{ width: `${stats[0].percentage}%` }}
                  />
                  <div
                    className={classes.greenShare}
                    style={{ width: `${stats[1].percentage}%` }}
                  />
                </div>
              </div>
              {stats.map((item, i) => (
                <div className={classes.poolStats} key={i}>
                  <div className="d-flex align-items-center gap-1">
                    <div
                      className={classes.sqaureDot}
                      style={{ backgroundColor: item.color }}
                    ></div>
                    <div className={classes.nameText}>{item.name}</div>
                    <div
                      className={classes.percentText}
                      style={{ color: item.color }}
                    >
                      {item.percentage}%
                    </div>
                  </div>
                  <h3>{item.amount}</h3>
                </div>
              ))}
            </Card>
          </div>

          {/* Recent Payouts */}
          <div className="col-md-4 mt-3 mt-md-0">
            <Card className={classes.poolCard}>
              <h4>RECENT PAYOUTS</h4>
              <div className={classes.payoutContainer}>
                <table className={classes.payoutTable}>
                  <thead>
                    <tr>
                      <th className={classes.th}>Account ID</th>
                      <th className={`${classes.th} ${classes.amount}`}>
                        Amount
                      </th>
                      <th className={`${classes.th} ${classes.status}`}>
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.recentPayouts?.length === 0 ? (
                      <tr>
                        <td colSpan="3" className={classes.td}>
                          No recent payouts
                        </td>
                      </tr>
                    ) : (
                      data?.recentPayouts?.map((payout, index) => (
                        <tr key={index}>
                          <td className={classes.td}>{payout.accountId}</td>
                          <td className={`${classes.td} ${classes.amount}`}>
                            {payout.amount}
                          </td>
                          <td className={`${classes.td} ${classes.status}`}>
                            {payout.status}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>

          {/* Live Funding Capacity */}
          <div className="col-md-4 mt-3 mt-md-0">
            <Card className={classes.poolCard}>
              <div
                className={`${classes.poolCardHeader} d-flex align-items-center justify-content-between gap-2`}
              >
                <h4>Live Funding Capacity (DAE)</h4>{" "}
                <a
                  href="https://docs.proptrading.fun/community-pool/payout-backing-mechanism/live-funding-capacity"
                  target="_blank"
                >
                  Learn more
                </a>
              </div>
              <div className={classes.payoutContainer}>
                <table className={classes.payoutTable}>
                  <thead>
                    <tr>
                      <th className={classes.th}>Metric</th>
                      <th
                        className={`${classes.th} ${classes.amount} text-end`}
                      >
                        Value
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {metrics?.length === 0 ? (
                      <tr>
                        <td colSpan="3" className={classes.td}>
                          No live funding data
                        </td>
                      </tr>
                    ) : (
                      metrics.map((metric, index) => {
                        const numericValue = Number(
                          String(metric.value).replace(/[$,]/g, "")
                        );
                        const isNegative = numericValue < 0;

                        const isDrawdownMetric =
                          metric.metric === "Total Drawdown Exposure Used" ||
                          metric.metric === "Remaining Drawdown Capacity";

                        const valueStyle = {
                          color: isDrawdownMetric
                            ? index == 1
                              ? "#970B0B"
                              : index == 2 && "#30970B"
                            : undefined,
                        };

                        // Format value: currency only for drawdown metrics
                        const formattedValue = isDrawdownMetric
                          ? (isNegative ? "-" : "") +
                            new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 0,
                            }).format(Math.abs(numericValue))
                          : metric.value; // Just show the raw number for Total Funded Traders

                        return (
                          <tr key={index}>
                            <td className={`${classes.td} position-relative`}>
                              <div className="d-flex align-items-center gap-2">
                                {metric.metric}
                                <span
                                  className="info-icon"
                                  onMouseEnter={() => setHoveredIndex(index)}
                                  onMouseLeave={() => setHoveredIndex(null)}
                                >
                                  <AiOutlineInfoCircle
                                    size={16}
                                    color="#CECECE"
                                  />
                                </span>
                              </div>
                            </td>
                            <td
                              className={`${classes.td} ${classes.amount} text-end`}
                              style={valueStyle}
                            >
                              {formattedValue}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                {hoveredIndex !== null && (
                  <div
                    className={classes.tooltipBox}
                    style={{ top: tooltipTop(hoveredIndex) }}
                  >
                    {metrics[hoveredIndex].tip}
                  </div>
                )}
              </div>
            </Card>
          </div>
        </div>

        {/* MOBILE VIEW: Horizontal scroll */}
        <div className="d-md-none my-4">
          <Card className={classes.poolCard}>
            <h4>Pool OVERVIEW</h4>
            <div className={classes.shareContainer}>
              <div
                className={`${classes.shareWrapper} d-flex align-items-center gap-1`}
              >
                <div
                  className={classes.redShare}
                  style={{ width: `${stats[0].percentage}%` }}
                />
                <div
                  className={classes.greenShare}
                  style={{ width: `${stats[1].percentage}%` }}
                />
              </div>
            </div>
            {stats.map((item, i) => (
              <div className={classes.poolStats} key={i}>
                <div className="d-flex align-items-center gap-1">
                  <div
                    className={classes.sqaureDot}
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <div className={classes.nameText}>{item.name}</div>
                  <div
                    className={classes.percentText}
                    style={{ color: item.color }}
                  >
                    {item.percentage}%
                  </div>
                </div>
                <h3>{item.amount}</h3>
              </div>
            ))}
          </Card>
        </div>

        <div
          className={`d-flex d-md-none  overflow-auto  ${classes.mobileScrollWrapper}`}
          ref={scrollRef}
        >
          {/* RECENT PAYOUTS CARD */}
          <div className={classes.scrollItem}>
            <Card className={classes.poolCard}>
              <h4>RECENT PAYOUTS</h4>
              <div className={classes.payoutContainer}>
                <table className={classes.payoutTable}>
                  <thead>
                    <tr>
                      <th className={classes.th}>Account ID</th>
                      <th className={`${classes.th} ${classes.amount}`}>
                        Amount
                      </th>
                      <th className={`${classes.th} ${classes.status}`}>
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.recentPayouts?.length === 0 ? (
                      <tr>
                        <td colSpan="3" className={classes.td}>
                          No recent payouts
                        </td>
                      </tr>
                    ) : (
                      data?.recentPayouts?.map((payout, index) => (
                        <tr key={index}>
                          <td className={classes.td}>{payout.accountId}</td>
                          <td className={`${classes.td} ${classes.amount}`}>
                            {payout.amount}
                          </td>
                          <td className={`${classes.td} ${classes.status}`}>
                            {payout.status}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>

          {/* LIVE FUNDING CARD */}
          <div className={classes.scrollItem}>
            <Card className={classes.poolCard}>
              <div
                className={`${classes.poolCardHeader} d-flex align-items-center justify-content-between gap-2`}
              >
                <h4>Live Funding Capacity (DAE)</h4>{" "}
                <a
                  href="https://docs.proptrading.fun/community-pool/payout-backing-mechanism/live-funding-capacity"
                  target="_blank"
                >
                  Learn more
                </a>
              </div>
              <div className={classes.payoutContainer}>
                <table className={classes.payoutTable}>
                  <thead>
                    <tr>
                      <th className={classes.th}>Metric</th>
                      <th
                        className={`${classes.th} ${classes.amount} text-end`}
                      >
                        Value
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {metrics?.length === 0 ? (
                      <tr>
                        <td colSpan="3" className={classes.td}>
                          No live funding data
                        </td>
                      </tr>
                    ) : (
                      metrics.map((metric, index) => {
                        const numericValue = Number(
                          String(metric.value).replace(/[$,]/g, "")
                        );
                        const isNegative = numericValue < 0;

                        const isDrawdownMetric =
                          metric.metric === "Total Drawdown Exposure Used" ||
                          metric.metric === "Remaining Drawdown Capacity";

                        const valueStyle = {
                          color: isDrawdownMetric
                            ? isNegative
                              ? "#970B0B"
                              : "#30970B"
                            : undefined,
                        };

                        // Format value: currency only for drawdown metrics
                        const formattedValue = isDrawdownMetric
                          ? (isNegative ? "-" : "") +
                            new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 0,
                            }).format(Math.abs(numericValue))
                          : metric.value; // Just show the raw number for Total Funded Traders

                        return (
                          <tr key={index}>
                            <td className={`${classes.td} position-relative`}>
                              <div className="d-flex align-items-center gap-2">
                                {metric.metric}
                                <span
                                  className="info-icon"
                                  onMouseEnter={() => setHoveredIndex(index)}
                                  onMouseLeave={() => setHoveredIndex(null)}
                                >
                                  <AiOutlineInfoCircle
                                    size={16}
                                    color="#CECECE"
                                  />
                                </span>
                              </div>
                            </td>
                            <td
                              className={`${classes.td} ${classes.amount} text-end`}
                              style={valueStyle}
                            >
                              {formattedValue}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                {hoveredIndex !== null && (
                  <div
                    className={classes.tooltipBox}
                    style={{ top: tooltipTop(hoveredIndex) }}
                  >
                    {metrics[hoveredIndex].tip}
                  </div>
                )}
              </div>
            </Card>
          </div>
        </div>

        {/* MOBILE DOT INDICATORS */}
        <div
          className={`d-flex justify-content-center gap-2 mt-2 d-md-none ${classes.dots}`}
        >
          {[0, 1].map((i) => (
            <span
              key={i}
              className={`${classes.dot} ${
                i === activeIndex ? classes.activeDot : ""
              }`}
            ></span>
          ))}
        </div>
      </>

      <div className="mt-5">
        <h2>History</h2>
        <Card className={classes.historyCard}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th className={classes.th}>Date</th>
                <th className={classes.th}>Transaction Type</th>
                <th className={classes.th}>Amount</th>
                <th className={classes.th}>Trade/Account ID</th>
                <th className={classes.th}>Transaction Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.transactions?.length === 0 ? (
                <tr>
                  <td colSpan="5" className={classes.td}>
                    No transactions
                  </td>
                </tr>
              ) : (
                <>
                  {data?.transactions.map((transaction, index) => (
                    <tr key={index}>
                      <td className={classes.td}>{transaction.date}</td>
                      <td className={classes.td}>{transaction.type}</td>
                      <td className={classes.td}>{transaction.amount}</td>
                      <td className={classes.td}>{transaction.accountId}</td>
                      <td className={classes.td}>
                        {getStatusIcon(transaction.status)} {transaction.status}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
};

export default PayoutPool;
